export default __webpack_public_path__ + "static/media/node.cdc0fcba.PNG";